import DesignButton from 'components/button/DesignButton';
import DesignInput from 'components/input/DesignInput';
import DesignSelect from 'components/select/DesignSelect';
import useAgenciesDataStore from 'core/hooks/useAgenciesDataStore';

export interface CourierSearchProps {
  dateInputValue: string | null;
  dateChangeHandler: (e: any) => void;
  agencyInputValue: string | null;
  agencyChangeHandler: ({ value }: any) => void;
  refreshHandler: () => void;
}

const CourierSearch = ({
  dateInputValue,
  dateChangeHandler,
  agencyInputValue,
  agencyChangeHandler,
  refreshHandler,
}: CourierSearchProps) => {
  const { agenciesData, areAgenciesLoading } = useAgenciesDataStore();

  const agenciesOptions = agenciesData?.map((x: any) => ({
    value: x.id,
    label: x.name,
  }));
  return (
    <div className="flex items-end justify-between">
      <div className="flex w-1/3 flex-col">
        <label htmlFor="statisticsDate">Date</label>
        <DesignInput
          name="date"
          type="date"
          max="today"
          step={1}
          id="statisticsDate"
          onChanceHandler={dateChangeHandler}
          value={dateInputValue ?? ''}
        />
      </div>
      <div className="flex w-1/2 flex-col">
        <label htmlFor="statisticsAgency">Select Agency</label>
        <DesignSelect
          loading={areAgenciesLoading}
          options={agenciesOptions}
          onChange={agencyChangeHandler}
          value={agenciesOptions.filter((x) => x.value === agencyInputValue)}
        />
      </div>
      <div className="w-auto">
        <DesignButton
          disabled={!dateInputValue || !agencyInputValue}
          onClickHandler={refreshHandler}
        >
          <svg width="14" height="14" viewBox="0 0 15 17" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.3735 3.58408C4.31702 2.74028 5.50503 2.21934 6.7649 2.09698C8.02476 1.97462 9.29083 2.25721 10.3791 2.90368L9.3837 2.94148C9.19499 2.95009 9.01732 3.03292 8.88941 3.17192C8.7615 3.31093 8.69369 3.49484 8.70075 3.68361C8.70782 3.87238 8.78918 4.05071 8.92712 4.17976C9.06507 4.30882 9.24842 4.37814 9.43724 4.37263L12.2722 4.26763C12.4662 4.2552 12.6473 4.16648 12.776 4.02087C12.9047 3.87526 12.9704 3.68461 12.9589 3.49063L12.8539 0.689229C12.8504 0.595043 12.8282 0.502494 12.7888 0.4169C12.7493 0.331305 12.6933 0.254356 12.624 0.190481C12.5567 0.124756 12.4762 0.0739551 12.3879 0.0413905C12.2996 0.00882594 12.2055 -0.00477168 12.1116 0.00148037C12.0177 0.00486494 11.9253 0.0267336 11.8399 0.0658317C11.7544 0.10493 11.6775 0.160492 11.6135 0.229341C11.5495 0.298191 11.4998 0.378971 11.467 0.467072C11.4343 0.555173 11.4193 0.648865 11.4228 0.742782L11.4669 1.89778C10.1053 0.973179 8.4727 0.532666 6.83086 0.646908C5.18901 0.761149 3.63312 1.42352 2.41274 2.52778C1.43362 3.41437 0.711947 4.54881 0.323858 5.81139C-0.0642313 7.07398 -0.10434 8.4179 0.207748 9.70138C0.245306 9.85731 0.334344 9.99602 0.460475 10.0951C0.586606 10.1942 0.742446 10.2478 0.902835 10.2474C0.960578 10.2483 1.01818 10.2412 1.074 10.2264C1.25805 10.1811 1.41666 10.0648 1.51507 9.9028C1.61348 9.74082 1.64366 9.54643 1.599 9.36223C1.3479 8.32876 1.38051 7.24666 1.6934 6.23019C2.00628 5.21372 2.58783 4.3006 3.37664 3.58723"
              className="fill-design-black dark:fill-white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.5886 6.42756C14.555 6.29012 14.4813 6.16575 14.377 6.07018C14.2727 5.9746 14.1423 5.91214 14.0025 5.89067C13.8626 5.8692 13.7196 5.88969 13.5914 5.94956C13.4632 6.00944 13.3557 6.10598 13.2824 6.227C13.2331 6.30679 13.2002 6.39565 13.1858 6.48834C13.1713 6.58104 13.1756 6.67569 13.1984 6.7667C13.4751 7.91132 13.4036 9.11252 12.993 10.2162C12.5824 11.3199 11.8514 12.2758 10.8937 12.9611C9.93611 13.6465 8.79555 14.0301 7.61839 14.0627C6.44124 14.0954 5.28116 13.7756 4.28701 13.1444L5.39687 13.0394C5.58609 13.022 5.76066 12.9301 5.88215 12.784C6.00365 12.6379 6.06213 12.4495 6.04472 12.2603C6.02732 12.0711 5.93545 11.8965 5.78934 11.775C5.64323 11.6535 5.45484 11.595 5.26562 11.6124L2.44112 11.8676C2.25254 11.8857 2.07878 11.9777 1.95779 12.1235C1.8368 12.2693 1.77841 12.457 1.79536 12.6457L2.04946 15.468C2.06987 15.6535 2.16062 15.8241 2.30302 15.9446C2.44543 16.0651 2.62865 16.1264 2.81492 16.1159H2.82541C2.91876 16.1073 3.00948 16.0803 3.09237 16.0365C3.17525 15.9927 3.24868 15.933 3.30842 15.8608C3.36945 15.7887 3.41531 15.705 3.44328 15.6148C3.47124 15.5246 3.48073 15.4297 3.47117 15.3358L3.37457 14.2522C4.60296 15.0744 6.051 15.5064 7.52909 15.4918C9.00718 15.4772 10.4464 15.0166 11.6583 14.1702C12.8702 13.3239 13.7982 12.1313 14.3209 10.7486C14.8435 9.36591 14.9365 7.85762 14.5875 6.42124"
              className="fill-design-black  dark:fill-white"
            />
          </svg>
        </DesignButton>
      </div>
    </div>
  );
};
export default CourierSearch;
